import { Pipe, PipeTransform } from '@angular/core';
import { isIconTypeCustom } from '../utils/cobrand.utils';

@Pipe({
    name: 'isIconCustom',
    standalone: false
})
export class IsIconCustomPipe implements PipeTransform {
    transform(applicationIcon: string): boolean {
        return isIconTypeCustom(applicationIcon);
    }
}
